<template>
  <div class="listPage">
    <b-row class="mt-2 mb-5 justify-content-start">
      <!-- Left section filtre -->
      <b-col cols="4" lg="2" xl="1">
        <b-button class="btnFilter"
          @click="displayFilter = !displayFilter">
          <i v-if="displayFilter" class="fa-light fa-minus"></i>
          <i v-else class="fa-light fa-plus"></i>
          {{ $t('filter.fltr') }}
        </b-button>
      </b-col>
      <b-col cols="4" lg="2" xl="1">
        <b-button class="btnFilter"
          @click="refreshInbox()">
          <i class="fa-light fa-rotate-right"></i>
          {{ $t('common.rfrsh') }}
        </b-button>
      </b-col>
    </b-row>
    <b-row class="justify-content-start" v-if="displayFilter">
      <!--Filtre Name -->
      <b-col sm="6" lg="3" cols="12" class="filter-item mb-5">
        <label class="filter-item-title" for="tracking-name">{{ $t('tracking.file_name') }}</label>
        <span class="filter-item-content">
          <input v-model="Name" id="tracking-name"
            type="text"
            :class="{'filter-item-input': true, 'filter-item-input-complete': Name}"
            :placeholder="$t('tracking.name')">
        </span>
      </b-col>

      <!-- Filtre date de début -->
      <b-col sm="6" lg="3" cols="12" class="filter-item mb-5">
        <datetime-picker-custom class="z-1" format="DD/MM/YYYY H:i:s"
          :class="{'filter-item-input': true, 'filter-item-input-complete': dateBegin}"
          :inputLabel="$t('common.date_start_label')"
          customInputParentClass="filter-item-content"
          customInputClass="w-100"
          :maxLength="19"
          :placeholderValue="$t('common.datetime_picker_empty_date')"
          inputIcon="fa-solid fa-calendar"
          v-model="dateBegin">
        </datetime-picker-custom>
      </b-col>

      <!-- Filtre date de fin -->
      <b-col sm="6" lg="3" cols="12" class="filter-item mb-5">
        <datetime-picker-custom class="z-1" format="DD/MM/YYYY H:i:s"
          :class="{'filter-item-input': true, 'filter-item-input-complete': dateEnd}"
          :inputLabel="$t('common.date_end_label')"
          customInputParentClass="filter-item-content"
          customInputClass="w-100"
          :maxLength="19"
          :placeholderValue="$t('common.datetime_picker_empty_date')"
          inputIcon="fa-solid fa-calendar"
          v-model="dateEnd">
        </datetime-picker-custom>
      </b-col>

      <!-- Bouton Effacer et Appliquer -->
      <b-col lg="3" cols="12" class="d-flex flex-row-reverse mt-3">
        <b-button size="sm"
          @click="applyFilter()">
          {{ $t('common.srch') }}
        </b-button>
        <b-button class="mr-3" size="sm"
          @click="clearFilterFields"
          :disabled="!hasInputFilter">
          {{ $t('filter.clr_fltr_field') }}
        </b-button>
      </b-col>
    </b-row>
    <div class="d-flex justify-content-end" v-if="TracksList.length > 0">
      <b-button class="btnFilter_2 mx-3"
        @click="extractCSV()">
        <i class="fa-light fa-upload fs-14px"></i>
        <span class="fab-label">{{ $t('common.extract_list') }}</span>
      </b-button>
    </div>
    <spinner v-if="activateSpinner"></spinner>
    <b-table hover v-else-if="TracksList.length > 0"
      class="table table-striped"
      :fields="fields"
      :items="TracksList"
      :selectable="TracksList.length > 0"
      :empty-text="$t('common.security.no_result')"
      @row-selected="seeTracksDetails">
      <template #cell(FileName)="data">
        <span>{{ data.value }}</span>
      </template>
      <!--                    <template #cell(File)="data">-->
      <!--                      <div class="d-flex justify-content-center align-item-center">-->
      <!--                        <div>-->
      <!--                          <i class="fa fa-eye cursor pl-2 pr-1 color-var-actionButtonColorBlue" @click="seeJson(data.item.idTrackingBulk, 'trackingBulk', 'see')"></i>-->
      <!--                        </div>-->
      <!--                        <div>-->
      <!--                          <i class="fa fa-download cursor px-2 color-var-actionButtonColorBlue" @click="seeJson(data.item.idTrackingBulk, 'trackingBulk', 'download')"></i>-->
      <!--                        </div>-->
      <!--                      </div>-->
      <!--                    </template>-->
      <template #cell(Date)="data">
        <span>{{ getDate(data.value) }}</span>
      </template>
    </b-table>
    <div v-else class="d-flex justify-content-center">
      <span class="noResult">
        {{ $t('common.no_result') }}
      </span>
    </div>
    <b-row class="mt-5">
      <b-col>
        <cm-pagination
          :maxResultsByPage="paginationObject.maxResults"
          :firstIndex="paginationObject.firstIndex"
          :nbResultsTotal="paginationObject.nbResultsTotal"
          :refreshEvent="paginationObject.refresh">
        </cm-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import moment from 'moment'
import Pagination from '@/components/common/pagination.vue'
import Spinner from '@/components/common/spinner.vue'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'
import dateTimePicker from '@/components/common/dateTimePicker.vue'
import {downloadFileWithDefinedHeaders} from "@/helpers/download";


export default {
  name: 'TrackingBulkPage',
  components: {
    'cm-pagination': Pagination,
    'spinner': Spinner,
    'datetime-picker-custom': dateTimePicker,
  },
  props: {
    additionalClass: {
      type: String,
      default: ''
    },
    type: {
      default: 'DDV',
      type: String
    }
  },
  computed: {
    buttonsListStyle () {
      return (!this.isSmartphoneOS) ? 'border: 1px solid #aaa;' : ''
    },
    fields () {
      let fields
      fields = [
        { key: 'Date', label: this.$i18n.t('tracking.date'), class: 'text-center', sortable: false },
        { key: 'FileName', label: this.$i18n.t('tracking.file_name'), class: 'text-center', sortable: false },
        // { key: 'File', label: this.$i18n.t('tracking.file'), class: 'text-center', sortable: false },
      ]

      return fields
    },
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
    company_nameDirection () {
      return ((this.sortField === 'company_name' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    statusVerificationDirection () {
      return ((this.sortField === 'statusVerification' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    activeDirection () {
      return ((this.sortField === 'active' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    hasInputFilter () {
      if (
          this.Name ||
          this.dateBegin || this.dateEnd) {
        return true
      }
      return false
    }
  },
  data () {
    return {
      activateSpinner: false,
      displayFilter: false,
      filterBy: '',
      hasDefaultFilter: false,
      idTrackAcc: '',
      statusVerification: '',
      mode: 1,
      identifier: '',
      technicalStatus: '',
      Name: '',
      IBAN: '',
      tabName: 1,
      dateBegin: '',
      dateEnd: '',
      noMore: false,
      pageCounter: 0,
      paginationObject: {},
      randomId: Math.random().toString(36).substr(2, 10),
      requestsNumber: '',
      scrollFlag: true,
      sortDirection: 'DESC',
      sortField: 'dateAction',
      trackActive: '',
      TracksList: [],
    }
  },
  created () {
    if (this.type == 'DDV'){
      this.tabName = 1
    }else{
      this.tabName = 2
    }
    // this.$bus.$emit('switch-selected-menu', '/trackingbulk/:id')
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: 'Tracking',
    })
    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 15
    this.paginationObject['nbResultsTotal'] = 0
    let that = this
    this.$bus.$off('refresh-cache-contacts')

    this.paginationObject['refresh'] = 'direct-inbox-filtered'
    this.$bus.$off('direct-inbox-filtered')
    this.$bus.$on('direct-inbox-filtered', index => {
      this.onRefresh(false, index)
      that.pageCounter = 0
    })

    this.$f7.initPullToRefresh()
    this.pageCounter = 0
    this.onRefresh(false)
    this.filterTypeGet = this.filterType
    this.$bus.emit('right-panel-set-feature', 'filter-messages')
  },
  mounted () {
    this.$$('.infinite-scroll-preloader').remove()
  },
  beforeDestroy () {
    let that = this
    that.$engine.tracking.cleanFilterCondition()
  },
  methods: {
    applyFilter (filterConditions = {}) {
      this.TracksList = []
      let that = this
      this.filterTypeGet = 'list'
      this.$engine.tracking.cleanFilterCondition()

      filterConditions.Name = this.Name
      filterConditions.dateEnd =  this.dateEnd != '' ?  moment(this.dateEnd , 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : ''
      filterConditions.dateBegin =  this.dateBegin != '' ?  moment(this.dateBegin , 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : ''
      filterConditions.maxResults = this.paginationObject.maxResults
      filterConditions.firstIndex = this.paginationObject.firstIndex

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0
      this.activateSpinner = true
      this.$engine.tracking.getTracksBulk(
        filterConditions
      ).then(resp => {
        let requests = {}
        that.paginationObject.nbResultsTotal = resp.data.nbTotaltrackingBulk
        that.paginationObject.nbResults = resp.data.trackingBulk.length
        requests = resp.data.trackingBulk
        that.updateInbox(requests)
        // this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    toggleRightPanel () {
      this.$bus.emit('right-panel-toggle')
    },
    communicateChange () {
      this.$bus.emit('right-panel-filter-view-update-fields', this.filterFields)
    },
    clearFilterFields () {
      this.Name = ''
      this.dateEnd = ''
      this.dateBegin = ''
      this.communicateChange()
      // this.applyFilter()
    },
    attachInfinit () {
      if (this.$settings.inboxPreloaderRemoved ||
          this.$settings.sendboxPreloaderRemoved) {
        this.$f7.attachInfiniteScroll(this.$$('.infinite-scroll'))
        this.$engine.settings.set({inboxPreloaderRemoved: false})
      }
      this.scrollFlag = true
      this.noMore = false
    },
    detachInfinit () {
      this.$$('.infinite-scroll-preloader').remove()
      this.$f7.detachInfiniteScroll(this.$$('.infinite-scroll'))
      this.$engine.settings.set({inboxPreloaderRemoved: true})
      if (!this.emptyBox) {
        this.scrollFlag = false
        this.noMore = true
      }
    },
    onClear () {
      this.filterBy = ''
      this.attachInfinit()
    },
    onDisable () {
      this.attachInfinit()
    },
    onEnable () {
      this.detachInfinit()
    },
    onRefresh (noAttach = false, index = 1) {
      let that = this
      this.pageCounter = 0
      this.paginationObject['firstIndex'] = index
      this.paginationObject['nbResultsTotal'] = 0

      this.activateSpinner = true
      let filterConditions = {

        Name: this.Name,
        dateEnd: this.dateEnd != '' ?  moment(this.dateEnd , 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : '',
        dateBegin: this.dateBegin != '' ?  moment(this.dateBegin , 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : '',
        maxResults :this.paginationObject.maxResults,
        firstIndex :this.paginationObject.firstIndex,
      }
      this.$engine.tracking.getTracksBulk(
        filterConditions
      ).then(resp => {
        this.TracksList = []
        let requests = {}
        if (resp.data) {
          that.paginationObject.nbResultsTotal = resp.data.nbTotaltrackingBulk
          that.paginationObject.nbResults = resp.data.nbTotaltrackingBulk
          requests = resp.data.trackingBulk
          that.updateInbox(requests, noAttach)
          that.$f7.pullToRefreshDone()
          that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
        }
        that.activateSpinner = false

      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that)
      })
    },
    extractCSV (){
      let that = this
      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0

      let filterConditions = {
        maxResults :this.paginationObject.maxResults,
        firstIndex :this.paginationObject.firstIndex,
        dateBegin : this.dateEnd != '' ?  moment(this.dateEnd , 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : '',
        dateEnd : this.dateBegin != '' ?  moment(this.dateBegin , 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : '',
        Type : this.tabName == 1 ? 'DDV':'DDD',
        extract : 1,
      }
      this.$engine.tracking.getTracksBulk(
        filterConditions
      ).then(resp => {
        that.$f7.hidePreloader()
        const linkSource = 'data:text/csv;charset:utf-8;base64,' + resp.data
        const downloadLink = document.createElement('a')
        let today = moment()
        const fileName = that.$t('Webheader.tracking_bulk') + '_' + today.unix() + '.csv'
        if (
          this.$f7.device.os === 'android' ||
          this.$f7.device.os === 'ios'
        ) {
          downloadFileWithDefinedHeaders(this, fileName, linkSource)
        } else {
          downloadLink.href = linkSource
          downloadLink.download = fileName
          downloadLink.click()
        }
        this.$f7.alert('', this.$i18n.t('common.exprt_succ'))

      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    onSearch (query, found) {
      this.filterBy = query
    },
    changeTabName (tabName) {
      this.tabName = tabName
      this.onRefresh()
    },
    refreshInbox () {
      this.onRefresh()
    },
    activateDetail (id) {
      let that = this
      loadPage(that, {url: '/trackingbulk/' + id})
    },
    reOrderBy (column) {
      this.TracksList = []
      let that = this
      if (this.sortField === column) {
        this.sortDirection = this.sortDirection === 'ASC' ? 'DESC' : 'ASC'
      } else {
        this.sortField = column
        switch (column) {
          case 'dateAction':
            this.sortDirection = 'DESC'
        }
      }
      let filterConditions
      this.$engine.tracking.getTracksBulk(
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
        filterConditions
      ).then(resp => {
        let requests = {}
        that.paginationObject.nbResultsTotal = resp.data.nbTotaltrackingBulk
        that.paginationObject.nbResults = resp.data.trackingBulk.length
        requests = resp.data.trackingBulk
        that.updateInbox(requests, false)
        that.$f7.pullToRefreshDone()
        that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
        that.activateSpinner = false
      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that)
      })
    },
    updateInbox (requests, noAttach = false) {
      this.TracksList = requests
      if (requests.length === this.paginationObject['maxResults']) {
        if (!noAttach) {
          this.attachInfinit()
        }
      } else {
        this.detachInfinit()
      }
    },
    seeTracksDetails (items) {
      this.activateDetail(items[0].idTrackingBulk)
    },
    isCSV(str) {
      const lines = str.split('\n')
      return lines.length > 1 && lines[0].includes(';')
    },
    seeJson (IdMsg, service, action) {
      let that = this
      const id = IdMsg
      let dataDetails = {}
      this.$engine.tracking.getJSON({service, id})
      .then((resp) => {
        if (resp.data) {
          dataDetails.data = Buffer.from(resp.data.data, 'base64').toString('utf-8')
          dataDetails.type = service
          if (action === 'see') {
            that.$bus.emit('popup-json-details', dataDetails)
          } else {
            //download file
            let data = Buffer.from(resp.data.data, 'base64').toString('utf-8')
            // if (this.isXML(data)){
            //   const fileName = moment().format('YYYYMMDD_hhmmss_') + service + '.xml'
            //   const blob = new Blob([data], { type: 'text/xml' })
            //
            //   downloadFileWithDefinedHeaders(that, fileName, URL.createObjectURL(blob))
            //   that.$f7.alert('', that.$i18n.t('common.xml_downloaded'))
            // }
            // if (this.isJSON(data)){
            //   const fileName = moment().format('YYYYMMDD_hhmmss_') + service + '.json'
            //   const blob = new Blob([data], { type: 'application/json' })
            //
            //   downloadFileWithDefinedHeaders(that, fileName, URL.createObjectURL(blob))
            //   that.$f7.alert('', that.$i18n.t('common.json_downloaded'))
            // }
            if (this.isCSV(data)){
              const fileName = moment().format('YYYYMMDD_hhmmss_') + service + '.csv'
              const blob = new Blob([data], { type: 'text/csv' })

              downloadFileWithDefinedHeaders(that, fileName, URL.createObjectURL(blob))
              that.$f7.alert('', that.$i18n.t('common.csv_downloaded'))
            }
          }
        }
      })
      .catch((error) => {
        errorMessageAlert(error, that)
      })
    },
    canAddTrackingFile () {
      return this.$engine.rights.rightIs('tracking_bulk_add', true)
    },
    addTrackingFile () {
      let that = this
      loadPage(that, {url: '/trackingform/create/'})
    },
    getDate (date) {
      if (date != ''){
        return moment.utc(date).local().format('DD/MM/YYYY HH:mm')
      } else {
        return '-'
      }
    },
    showButtonImportLot () {
      return false
    }
  }
}
</script>
